import { useTranslation } from "next-i18next";
import Link from "next/link";
import React, { FC } from "react";

import LocaleSwitcher, { Props as LocaleSwitcherProps } from "@/components/LocaleSwitcher";

import { useIsArcade } from "@/hooks/useIsArcade";

import { ChunkedNav } from "@/interfaces/navigation-interface";

import { ArcadeFooterLocal } from "./arcade/footer-local";
import styles from "./footer.module.scss";

type Props = {
    navigationItems: ChunkedNav;
} & LocaleSwitcherProps;
export const APFooterLocal: React.FC<Props> = ({ locales, currentLocale, navigationItems }) => {
    const { t } = useTranslation();

    const links = navigationItems.map(([titleNavItem, children]) => (
        <div key={titleNavItem.id} className={styles.col}>
            <h3 className={styles.colHeader}>{titleNavItem.text}</h3>
            <ul>
                {children.flatMap((columns) =>
                    columns.map((child) => (
                        <li key={child.id}>
                            {child.link ? (
                                <Link prefetch={false} href={child.link}>
                                    {child.text}
                                </Link>
                            ) : (
                                child.text
                            )}
                        </li>
                    ))
                )}
            </ul>
        </div>
    ));

    return (
        <>
            {links}
            <div className={styles.localeSwitcher}>
                <h3 className={styles.colHeader}>{t("footer.localeSelect")}</h3>
                <LocaleSwitcher locales={locales} currentLocale={currentLocale} />
            </div>
        </>
    );
};

export const FooterLocal: FC<Props> = (props) => {
    const isArcade = useIsArcade();
    return isArcade ? <ArcadeFooterLocal {...props} /> : <APFooterLocal {...props} />;
};
